<template>
  <div class="list">
    <home-banner ref="homeBanner" :height="400"></home-banner>
    <div class="clear"></div>
    <div class="wrap">
      <div class="listMainBox">
        <div class="listMainLeft fl" style="width: 190px; float: left">
          <div class="listSlidHd">
            <div class="title">
              <p>导航栏目</p>
            </div>
            <!-- <div class="title">
                {{slideHdTitle}}
              </div>
              <div class="txt">
                匠心营造 精益求精
              </div> -->
          </div>
          <div class="listSlid">
            <div class="listSlidList">
              <div
                class="listSlidList_line"
                v-for="(item, index) in slideList"
                :key="index"
              >
                <div
                  class="listSlidListInner"
                  :class="{ on: active == item.entTChannelUuid }"
                >
                  <!-- <a 
                  v-if="item.url && item.url !== ''" 
                  target="_blank" 
                  :href="item.url">
                  {{item.name}}
                  </a> -->
                  <!-- <a 
                    v-if="!item.url || item.url == ''" 
                    :href="item.catalog === 1 ? `/listPage/${item.entTChannelUuid}` : item.catalog === 2 ? `/list/${item.entTChannelUuid}` : `/listPic/${item.entTChannelUuid}`">
                    {{item.name}}
                  </a> -->
                  <a
                    v-if="
                      item.child.length &&
                      (!item.child[0].url || item.child[0].url == '')
                    "
                    :href="
                      item.catalog == 1
                        ? `/listPage/${item.child[0].entTChannelUuid}`
                        : item.catalog == 2
                        ? `/list/${item.child[0].entTChannelUuid}`
                        : `/listPic/${item.child[0].entTChannelUuid}`
                    "
                  >
                    {{ item.name }}
                  </a>
                  <a
                    v-if="!item.child.length"
                    :href="
                      item.catalog == 1
                        ? `/listPage/${item.entTChannelUuid}`
                        : item.catalog == 2
                        ? `/list/${item.entTChannelUuid}`
                        : `/listPic/${item.entTChannelUuid}`
                    "
                  >
                    {{ item.name }}
                  </a>
                </div>
                <!-- <div class="thirdNav" v-if="item.child.length != 0">
                  <div
                    class="thirdNav_line"
                    v-for="(item1, index1) in item.child"
                    :key="index1"
                    :class="{ on: item1.name == isClickid2 }"
                  >
                    <a v-if="item1.url && item1.url !== ''" target="_blank" :href="item1.url">
                      {{ item1.name }}
                    </a>
                    <a
                      v-if="!item1.url || item1.url == ''"
                      :href="
                        item1.catalog === 1
                          ? `/listPage/${item.entTChannelUuid}`
                          : item1.catalog === 2
                          ? `/list/${item1.entTChannelUuid}`
                          : `/listPic/${item1.entTChannelUuid}`
                      "
                    >
                      {{ item1.name }}
                    </a>
                  </div>
                </div> -->
              </div>
            </div>
          </div>
          <div class="listcontact">
            <div class="listcontacttop">
              <p>联系我们</p>
            </div>
            <div class="listcontactbottom">
              <p style="font-size: 14px; font-weight: bold; padding: 10px">
                甘肃第九建设集团有限责任公司
              </p>
              <p style="font-size: 14px; padding: 10px">
                地址：甘肃省武威市凉州区南关中路169号
              </p>
              <p style="font-size: 14px; padding: 10px">电话：0935-6181043</p>
            </div>
          </div>
        </div>
        <div class="listMainRight fr">
          <div class="listWrap">
            <div class="listHd clearfloat">
              <div class="listpot">{{ slideHdTitle }}</div>
              <div class="fl listHdGrop">
                <span class="listHdIco"><i class="el-icon-s-home"></i></span>
                您当前所在位置：<a href="/">首页</a> >
                <span v-if="viewSlideHdParent"
                  ><a :href="slideHdParentUrl">{{ slideHdParentName }}</a>
                </span>
                <span v-if="slideHdName2 != ''" class="txt"
                  >> {{ slideHdName2 }} </span
                ><span v-if="isthird" class="txt">> {{ slideHdName1 }}</span>
              </div>
            </div>
            <div class="listContainer">
              <div class="newsDetails">
                <div class="clear"></div>
                <div class="h3 text-center">{{ newsitem.title }}</div>
                <div class="des text-center">
                  <span
                    >发布时间：{{
                      dayjs(newsitem.publishDate).format("YYYY-MM-DD")
                    }}</span
                  >
                </div>
                <div
                  class="content_body nrstyle"
                  v-html="newsitem.content"
                ></div>
              </div>
            </div>
          </div>
        </div>
        <div style="clear: both"></div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getChildChannel,
  getChannelInfo,
  getArtInfo,
  increaseViews,
  getNavChannel,
} from "@/api/common";
import homeBanner from "@/components/swiper.vue";
export default {
  name: "list",
  components: {
    homeBanner,
  },
  data() {
    return {
      isthird: false,
      isClickid: "",
      isClickid2: "",
      parentId: "",
      slideHdTitle: "",
      viewSlideHdParent: true,
      slideHdParentName: "",
      slideHdParentUrl: "",
      slideHdName1: "",
      slideHdName2: "",
      hdTitle: "",
      hdName: "",
      pageCont: "",
      active: 0,
      slideHd: {
        title: "新闻动态",
      },
      slideList: [
        //   {
        //     name: '网站首页',
        //     child: ''
        //   },
        //   {
        //     name: '集团新闻',
        //     child: ''
        //   },
        //   {
        //     name: '建投要闻',
        //     child: ''
        //   },
        //   {
        //     name: '企业文化',
        //     child: ''
        //   },
        //   {
        //     name: '科技创新',
        //     child: ''
        //   },
        //   {
        //     name: '党建工作',
        //     child: ''
        //   },
        //   {
        //     name: '消防专栏',
        //     child: ''
        //   },
        //   {
        //     name: '联系我们',
        //     child: ''
        //   }
      ],
      pageSize: 10,
      pageNum: 1,
      total: 0,
      listData: [],
      newsitem: {},
    };
  },
  mounted() {
    var _this = this;
    _this.active = _this.$route.params.parentId;
    _this.listId = _this.$route.params.id;
    _this.parentId = _this.$route.params.parentId;
    if (
      _this.$route.params.parentId == "0239" ||
      _this.$route.params.parentId == "0238" ||
      _this.$route.params.parentId == "0242" ||
      _this.$route.params.parentId == "0243"
    ) {
      _this.getNavChannel();
    } else {
      _this.getChannelInfo();
    }

    // _this.getChildChannel()
    // _this.getChannelInfo()
    _this.getArtInfo();
  },
  methods: {
    // 查询二级栏目
    getNavChannel() {
      var _this = this;
      let data = {
        applicationUuid: _this.webId,
      };
      console.log(344, data);
      getNavChannel(data).then((res) => {
        const { code, data } = res;
        if (code === 1 && data) {
          _this.slideList = data;
          console.log(2222, _this.slideList);
        }
      });
    },
    getChildChannel(id) {
      var _this = this;

      let data = {
        applicationUuid: _this.webId,
        parentUuid: id,
      };
      getChildChannel(data).then((res) => {
        const { code, data } = res;
        if (code === 1 && data) {
          _this.slideList = data;
          if (_this.slideList.length) {
            _this.viewSlideHdParent = true;
            let url = "";
            if (_this.slideList[0].catalog === 1) {
              url = `/listPage/${_this.slideList[0].entTChannelUuid}`;
            } else if (_this.slideList[0].catalog === 2) {
              url = `/list/${_this.slideList[0].entTChannelUuid}`;
            } else {
              url = `/listPic/${_this.slideList[0].entTChannelUuid}`;
            }
            _this.slideHdParentUrl = url;
          } else {
            _this.viewSlideHdParent = false;
          }
        }
      });
    },
    getChannelInfo() {
      var _this = this;
      let params1 = {
        channelUuid: _this.$route.params.parentId,
      };
      getChannelInfo(params1).then((res) => {
        const { code, data } = res;
        if (code === 1 && data) {
          if (data.parentUuid == "0") {
            _this.slideHdTitle = data.name;
            _this.slideHdParentName = data.name;
            return;
          }
          _this.slideHdName1 = data.name;
          let params2 = {
            channelUuid: data.parentUuid,
          };
          getChannelInfo(params2).then((res) => {
            const { code, data } = res;
            if (code === 1 && data) {
              if (data.parentUuid == "0") {
                _this.getChildChannel(data.entTChannelUuid);
                _this.slideHdParentName = data.name;
                _this.slideHdName2 = _this.slideHdName1;
                _this.slideHdTitle = _this.slideHdName2;
                _this.isthird = false;
              } else {
                _this.isthird = true;
                _this.getChildChannel(data.parentUuid);
                _this.slideHdName2 = data.name;
                _this.isClickid = data.channelId;
                let params3 = {
                  channelUuid: data.parentUuid,
                };
                getChannelInfo(params3).then((res) => {
                  const { code, data } = res;
                  if (code === 1 && data) {
                    _this.slideHdParentName = data.name;
                    _this.slideHdTitle = _this.slideHdName1;
                    _this.isClickid2 = _this.slideHdName1;
                  }
                });
              }
            }
          });
          let url = "";
          if (data.catalog === 1) {
            url = `/listPage/${_this.$route.params.parentId}`;
          } else if (data.catalog === 2) {
            url = `/list/${_this.$route.params.parentId}`;
          } else {
            url = `/listPic/${_this.$route.params.parentId}`;
          }
          _this.slideHdParentUrl = url;
          if (data.parentUuid == "0") {
            _this.viewSlideHdParent = false;
            return;
          }
        }
      });
    },
    //
    getArtInfo() {
      var _this = this;
      var applicationId = "";
      if (_this.$route.params.parentId == "7aacb4a1-c07d-4f15-9446-562aa849a6d8") {
        applicationId = _this.webIdGroup;
      } else {
        applicationId = _this.webId;
      }
      let data = {
        entTApplicationUuid: applicationId,
        entTArticleUuid: _this.$route.params.id,
      };
      getArtInfo(data).then((res) => {
        const { code, data } = res;
        if (code === 1 && data) {
          _this.newsitem = data;
        }
      });
    },
    increaseViews() {
      var _this = this;
      let data = {
        entTArticleUuid: _this.$route.params.id,
      };
      increaseViews(data).then((res) => {
        const { code, data } = res;
        if (code === 1 && data) {
          // _this.dataView = data
          // console.log(111,_this.dataView)
        }
      });
    },
  },
};
</script>

<style>
.listSlidListInner {
  background-color: #fff;
  font-weight: 400;
  height: 36px;
  line-height: 36px;
  margin-top: 10px;
  margin-bottom: 10px;
}
.listSlidListInner a {
  width: 164px;
  font-size: 14px;
  display: block;
  text-align: center;
}
.listSlidListInner.on a {
  /* background-color: #fff; */
  color: #0a66b9;
  border: 1px solid #0a66b9;
}
.listSlidList {
  margin-top: -36px;
  width: 186px;
}
.listSlidHd {
  /* width: 235px; */
  /* height: 230px; */
  /* background-color: #0062b3; */
  color: #ffffff;
  position: absolute;
  margin-top: 20px;
  z-index: 9999999;
}
.listSlidHd .pic {
  width: 64px;
  height: 73px;
  margin: 26px auto 0px auto;
}
.listSlidHd .title {
  width: 186px;
  height: 36px;
  line-height: 30px;
  text-align: center;
  font-size: 16px;
  margin-top: 30px;
  color: white;
  background-image: url(../assets/images/daohang.png);
  background-repeat: no-repeat;
  background-position: center;
}
.listSlidHd .txt {
  height: 24px;
  line-height: 24px;
  text-align: center;
  font-size: 16px;
  text-align: center;
  color: #97bde1;
  margin-top: 10px;
}

.listSlidList_line {
  width: 167px;
  height: 100%;
  margin: 0 auto;
  overflow: hidden;
  /* display: block;
  text-align: center;
  margin-top: 10px;
  font-size: 14px;
  border: 1px solid #f8f8f8;
  line-height: 30px;
  color: #333; */
}
.listSlidListInner:hover {
  /* background-color: #fff; */
  color: #0a66b9;
  /* border: 1px solid #0a66b9; */
}
.listSlidListInner a:hover {
  /* color: #fff; */
  color: #0a66b9;
  border: 1px solid #0a66b9;
  height: 36px;
  text-align: center;
  /* line-height: 30px; */
}
.wrap {
  height: auto;
}
.listMain {
  height: auto;
  overflow: hidden;
}
.clear {
  width: 100%;
  height: 20px;
  overflow: hidden;
  display: block;
  clear: both;
}
.newsDetails {
  font-family: 宋体;
}
.newsDetails .h3 {
  font-size: 30px;
  font-weight: bold;
}
.text-center {
  text-align: center;
}
.newsDetails .des {
  font-size: 14px;
  height: 40px;
  color: #caccce;
  line-height: 30px;
  border-bottom: 1px #f7ebec solid;
  margin: 10px 0px;
  padding-bottom: 10px;
  text-align: center;
}
.listMain {
  height: auto;
  overflow: hidden;
}
.contactBody {
  width: 100%;
  min-height: 500px;
  line-height: 30px;
}
.listcontactbottom {
  height: auto;
  border: 1px solid #f8f8f8;
  padding-bottom: 10px;
}
.listcontact {
  /* height: 192px; */
  width: 190px;
  float: left;
}
.listcontacttop {
  width: 186px;
  height: 36px;
  line-height: 30px;
  text-align: center;
  font-size: 16px;
  margin-top: 25px;
  color: white;
  background-image: url(../assets/images/daohang.png);
  background-repeat: no-repeat;
  background-position: center;
}
/* .wrap{
  font-family:宋体;
} */
/* .wrap{
  height:897px;
}
.listMain{
  height: 1010px;
} */
.listSlid {
  width: 235px;
  height: auto;
  margin-top: 126px;
}
.listpot {
  width: 200px;
  height: 35px;
  line-height: 35px;
  float: left;
  font-size: 14px;
}
.listHdGrop {
  width: 700px;
  text-align: right;
  height: 25px;
  line-height: 25px;
  margin-top: 10px;
  float: right;
  font-size: 12px;
  color: #9a9a9a;
}
.listHdGrop a {
  font-size: 12px;
  color: #9a9a9a;
}
.listHd {
  width: 100%;
  height: 35px;
  border-bottom: 1px solid #d6d6d6;
}
.listContainer {
  padding: 0 10px;
  margin-bottom: 25px;
}
.listContainer .contactBody p {
  padding: 0;
  line-height: 3em;
  text-indent: 0;
  font-family: 宋体;
  font-size: 18px;
  line-height: 28px;
  margin: 5px 0;
}
.newList {
  margin-bottom: 20px;
}
.thirdNav .thirdNav_line {
  margin: 0 0 3px 0;
  padding: 0;
  width: 100%;
  height: 30px;
  display: block;
  line-height: 30px;
  text-align: center;
  font-size: 13px;
  /* color: #000; */
  margin-bottom: 3px;
  font-weight: 400;
  background: none;
}
.thirdNav_line a {
  font-size: 14px;
  font-weight: normal;
  text-align: center;
  display: block;
  widows: 235px;
}
.thirdNav_line:hover {
  background-color: #0062b3;
  color: #fff;
}
.thirdNav_line a:hover {
  color: #fff;
}
.listWrap {
  width: 930px;
}
.nrstyle {
  padding: 0px 10px;
}
/* .nrstyle p span {
  font-weight: bold;
} */
.content_body {
  font-size: 16px;
  line-height: 30px;
  padding: 0;
}
.thirdNav .thirdNav_line.on a {
  background-color: #0062b3;
  color: #fff;
}
</style>
